module.exports = __webpack_public_path__ + "img/left-side-menu-select.adc07c4f.svg";